import React from "react";
import _ from "lodash";
import numeral from "numeral";
import Checkbox from "components/common/Checkbox";
import {
  parseTableData,
  filterDataToGroup,
} from "../IntegrationVerificationHelper";
import GroupDataTable from "./GroupDataTable";
import FilterControl from "./FilterControl";

const TABS = {
  LOCATION: "ad_location",
  INVENTORY: "inventory_format",
  BROWSER: "browser_category",
  SIGNAL: "secure_signal_presence",
};

const baseButton =
  "rounded px-4 py-1 font-semibold text-gray-700 bg-gray-300 border border-gray-400 hover:bg-gray-200 hover:text-gray-800";

const selectedButton =
  "rounded px-4 py-1 font-semibold text-blue-800 bg-blue-200";

class GeneralAdView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tabsObj: {},
      hideUmObj: {},

      isHideUm: true,

      selectedTab: TABS.LOCATION,

      expression: "",
      filterGroups: [],
      filterRecords: [],
      filterAmount: null,

      alias: [],
    };

    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    const { records, columns } = this.props;

    const tempColumns = [
      columns[0],
      columns[1],
      "",
      "b_impression",
      "o_impression",
      "um_impression",
      "total_impression",
    ];

    const tempHideUmColumns = [
      ...tempColumns.slice(0, 5),
      ...tempColumns.slice(6),
    ];

    const tempArrangeCol = [
      {
        key: "ext_gam_unit_id",
        label: "Ext Gam Unit Id",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "date",
        label: "Date",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "",
        label: "",
        groupfunc: (list) => {
          const temp = _.union(list);
          return temp.length > 1 ? "--" : temp[0];
        },
      },
      {
        key: "total_impression",
        label: "total imp. #",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "b_impression",
        label: "imp. #",
        group: "b",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "b_impression_percent",
        label: "imp. %",
        group: "b",
        parsefunc: ({ b_impression, total_impression }) => {
          return total_impression === 0 || b_impression === "-"
            ? 0
            : b_impression / total_impression;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "o_impression",
        label: "imp. #",
        group: "o",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "o_impression_percent",
        label: "imp. %",
        group: "o",
        parsefunc: ({ total_impression, o_impression }) => {
          return total_impression === 0 || o_impression === "-"
            ? 0
            : o_impression / total_impression;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
      {
        key: "um_impression",
        label: "imp. #",
        group: "um",
        groupfunc: (list) => {
          return _.sum(_.filter(list, (d) => _.isNumber(d)));
        },
        format: (val) => {
          return numeral(val).format("0,0");
        },
        align: "text-right",
      },
      {
        key: "um_impression_percent",
        label: "imp. %",
        group: "um",
        parsefunc: ({ total_impression, um_impression }) => {
          return total_impression === 0 || um_impression === "-"
            ? 0
            : um_impression / total_impression;
        },
        format: (val) => {
          return numeral(val).format("0.00%");
        },
      },
    ];
    const tempHideUmArrangeCol = tempArrangeCol.slice(0, 8);

    const tempTags = tempArrangeCol.slice(3).map((item) => ({
      value: item.key,
      label: item.label,
      group: item.group,
    }));
    const tempHideUmTags = tempHideUmArrangeCol.slice(3).map((item) => ({
      value: item.key,
      label: item.label,
      group: item.group,
    }));

    const tabsObj = {};
    const hideUmObj = {};

    const dateIdx = _.indexOf(columns, "date");
    const idIdx = _.indexOf(columns, "ext_gam_unit_id");
    const groupIdx = _.indexOf(columns, "group_type");
    const impIdx = _.indexOf(columns, "impression");

    _.values(TABS).forEach((tab) => {
      const newRecords = [];
      const hideUmRecords = [];

      tabsObj[tab] = {
        columns: _.cloneDeep(tempColumns),
        arrangeColumns: _.cloneDeep(tempArrangeCol),
      };
      tabsObj[tab].columns[2] = tab;
      tabsObj[tab].arrangeColumns[2].key = tab;
      tabsObj[tab].arrangeColumns[2].label = _.startCase(
        tab.split("_").slice(0, 2).join(" ")
      );
      tabsObj[tab].tags = [
        {
          value: tab,
          label: tabsObj[tab].arrangeColumns[2].label,
          type: "string",
        },
        ...tempTags,
      ];

      hideUmObj[tab] = {
        columns: _.cloneDeep(tempHideUmColumns),
        arrangeColumns: _.cloneDeep(tempHideUmArrangeCol),
      };
      hideUmObj[tab].columns[2] = tab;
      hideUmObj[tab].arrangeColumns[2].key = tab;
      hideUmObj[tab].arrangeColumns[2].label = _.startCase(
        tab.split("_").slice(0, 2).join(" ")
      );
      hideUmObj[tab].tags = [
        {
          value: tab,
          label: hideUmObj[tab].arrangeColumns[2].label,
          type: "string",
        },
        ...tempHideUmTags,
      ];

      const tabIdx = _.indexOf(columns, tab);
      const indexMap = new Map();

      _.forEach(records, (item) => {
        const date = item[dateIdx];
        const id = item[idIdx];
        const group = item[groupIdx];
        const imp = item[impIdx];
        const tab = item[tabIdx];

        let index = indexMap.get(`${date}|${id}|${tab}`);

        if (index === undefined) {
          newRecords.push([date, id, tab, 0, 0, 0, 0]);
          hideUmRecords.push([date, id, tab, 0, 0, 0]);
          index = newRecords.length - 1;
          indexMap.set(`${date}|${id}|${tab}`, index);
        }

        if (group === "b") {
          newRecords[index][3] += imp;
          hideUmRecords[index][3] += imp;
        } else if (group === "o") {
          newRecords[index][4] += imp;
          hideUmRecords[index][4] += imp;
        } else if (group === "um") {
          newRecords[index][5] += imp;
        }
        newRecords[index][6] += imp;
        if (group !== "um") {
          hideUmRecords[index][5] += imp;
        }
      });

      tabsObj[tab].records = newRecords;
      tabsObj[tab].result = parseTableData({
        columns: tabsObj[tab].columns,
        arrangeColumns: tabsObj[tab].arrangeColumns,
        records: newRecords,
        mainKey: "ext_gam_unit_id",
        subKey: "date",
        orderKey: "total_impression",
      });

      hideUmObj[tab].records = hideUmRecords;
      hideUmObj[tab].result = parseTableData({
        columns: hideUmObj[tab].columns,
        arrangeColumns: hideUmObj[tab].arrangeColumns,
        records: hideUmRecords,
        mainKey: "ext_gam_unit_id",
        subKey: "date",
        orderKey: "total_impression",
      });
    });

    this.setState(
      {
        tabsObj,
        hideUmObj,
        alias: [
          {
            value:
              "total_impression >= 10000 AND ( o_impression_percent <= 0.88 OR o_impression_percent >= 0.92)",
            label: "Quick Filter",
          },
          {
            func: (inputValue) =>
              `total_impression >= 10000 AND ( o_impression_percent <= ${(
                inputValue - 0.02
              ).toFixed(2)} OR o_impression_percent >= ${(
                inputValue + 0.02
              ).toFixed(2)})`,
            label: "Custom O Impression %",
          },
        ],
      },
      () => {
        this.handleSearch();
      }
    );
  }

  // Cause isHideUm flag need to exec filter data first
  handleSearch(expression = this.state.expression) {
    const { tabsObj, hideUmObj, isHideUm, selectedTab } = this.state;
    const {
      result: { records },
      arrangeColumns,
    } = isHideUm ? hideUmObj[selectedTab] : tabsObj[selectedTab];

    const result = filterDataToGroup({
      expression,
      records,
      columns: arrangeColumns,
      hasSubGroup: true,
    });

    if (result) {
      this.setState({
        expression,
        ...result,
      });
    }
  }

  render() {
    const {
      hideUmObj,
      tabsObj,
      selectedTab,
      isHideUm,
      alias,
      filterAmount,
      filterGroups,
      filterRecords,
    } = this.state;

    const dataObj = isHideUm ? hideUmObj : tabsObj;

    if (_.keys(dataObj).length === 0) {
      return null;
    }

    const { arrangeColumns, tags } = dataObj[selectedTab];

    const header = isHideUm ? (
      <tr className="bg-gray-100">
        <th className="border px-2 py-1 text-center" colSpan={6}></th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          b
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          o
        </th>
      </tr>
    ) : (
      <tr className="bg-gray-100">
        <th className="border px-2 py-1 text-center" colSpan={6}></th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          b
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          o
        </th>
        <th className="border px-2 py-1 text-center" colSpan={2}>
          um
        </th>
      </tr>
    );

    return (
      <>
        <div className="mb-2 flex w-full items-end justify-start gap-2">
          {_.values(TABS).map((tab) => (
            <button
              type="button"
              className={selectedTab === tab ? selectedButton : baseButton}
              style={{ width: "calc(16.66% - (0.5rem * 5) / 6)" }}
              key={tab}
              onClick={() =>
                this.setState({ selectedTab: tab }, () => {
                  this.handleSearch();
                })
              }
            >
              {_.startCase(tab.split("_").slice(0, 2).join(" "))}
            </button>
          ))}
          <div className="ml-auto flex items-center gap-1">
            <Checkbox
              isChecked={isHideUm}
              onChange={(value) =>
                this.setState({ isHideUm: value }, () => {
                  this.handleSearch();
                })
              }
            ></Checkbox>
            <span className="text-sm font-semibold text-gray-600 hover:text-gray-700">
              Hide um
            </span>
          </div>
        </div>

        <div className="mb-2">
          <FilterControl
            tags={tags}
            alias={alias}
            handleSearch={this.handleSearch}
          ></FilterControl>
        </div>

        <GroupDataTable
          header={header}
          records={filterRecords}
          groups={filterGroups}
          amount={filterAmount}
          mainKey="ext_gam_unit_id"
          subKey="date"
          columns={arrangeColumns}
        ></GroupDataTable>
      </>
    );
  }
}
export default GeneralAdView;
